import { getCategoryName, type CategoryItem, type CategoryTranslations } from "./categories";

/**
 * 카테고리 시트 왼쪽 레일(목차) 전용 짧은 이름(10-15). 모바일 레일은 글자 폭이 약 92px 라 정식
 * 이름(예 "シュノーケリング・ビーチ")이 두세 줄로 넘쳤다. 오른쪽 패널 섹션 제목은 정식 이름 그대로라
 * 무엇을 눌렀는지는 패널에서 확인된다. 여기 없는 코드는 정식 이름.
 */
const RAIL_NAMES: Record<string, CategoryTranslations> = {
  // 대분류(캡션)
  "10": { ko: "여행", en: "Travel", ja: "旅行", "zh-CN": "旅行", "zh-TW": "旅行" },
  "20": { ko: "테크", en: "Tech", ja: "デジタル", "zh-CN": "数码", "zh-TW": "數位" },
  "30": { ko: "뷰티·홈", en: "Beauty & Home", ja: "美容・生活", "zh-CN": "美妆家居", "zh-TW": "美妝家居" },
  "40": { ko: "키즈", en: "Kids", ja: "キッズ", "zh-CN": "儿童", "zh-TW": "兒童" },
  "50": { ko: "모빌리티", en: "Mobility", ja: "モビリティ", "zh-CN": "出行", "zh-TW": "出行" },
  // 중분류(항목)
  "10-01": { ko: "카메라", en: "Cameras", ja: "カメラ", "zh-CN": "相机", "zh-TW": "相機" },
  "10-02": { ko: "비치", en: "Beach", ja: "ビーチ", "zh-CN": "沙滩", "zh-TW": "沙灘" },
  "10-03": { ko: "스키", en: "Ski", ja: "スキー", "zh-CN": "滑雪", "zh-TW": "滑雪" },
  "10-05": { ko: "의상", en: "Costumes", ja: "衣装", "zh-CN": "服饰", "zh-TW": "服飾" },
  "10-06": { ko: "K-pop", en: "K-pop", ja: "K-POP", "zh-CN": "K-pop", "zh-TW": "K-pop" },
  "20-01": { ko: "스마트폰", en: "Phones", ja: "スマホ", "zh-CN": "手机", "zh-TW": "手機" },
  "20-02": { ko: "태블릿·PC", en: "Tablets & PCs", ja: "タブレット・PC", "zh-CN": "平板电脑", "zh-TW": "平板電腦" },
  "20-03": { ko: "와이파이", en: "Wi-Fi", ja: "Wi-Fi", "zh-CN": "Wi-Fi", "zh-TW": "Wi-Fi" },
  "20-04": { ko: "오디오", en: "Audio", ja: "オーディオ", "zh-CN": "音频", "zh-TW": "音訊" },
  "30-01": { ko: "뷰티기기", en: "Beauty", ja: "美容機器", "zh-CN": "美容仪器", "zh-TW": "美容儀器" },
  "30-02": { ko: "청소", en: "Cleaning", ja: "掃除", "zh-CN": "清洁", "zh-TW": "清潔" },
  "30-03": { ko: "생활가전", en: "Appliances", ja: "家電", "zh-CN": "家电", "zh-TW": "家電" },
  "40-01": { ko: "유아용품", en: "Baby", ja: "ベビー", "zh-CN": "婴儿", "zh-TW": "嬰兒" },
  "50-01": { ko: "바이크", en: "Bikes", ja: "バイク", "zh-CN": "两轮车", "zh-TW": "兩輪車" },
  "50-02": { ko: "휠체어", en: "Wheelchairs", ja: "車椅子", "zh-CN": "轮椅", "zh-TW": "輪椅" },
  "50-03": { ko: "자동차", en: "Cars", ja: "自動車", "zh-CN": "汽车", "zh-TW": "汽車" },
};

export function getCategoryRailName(
  category: CategoryItem,
  locale: keyof CategoryTranslations,
): string {
  return RAIL_NAMES[category.code]?.[locale] ?? getCategoryName(category, locale);
}
